<div class="m-card p-4 mb-2">
  <div class="d-flex">
    <ui-avatar class="me-2"
      [slIcon]="{name: 'office-stamp-document-alternate', theme: 'bold'}"
      [iconBackgroundColor]="'neutral-300'"
      [textColor]="'text-neutral-700'"
    ></ui-avatar>

    <div class="gap-1">
      @if(evidence?.link){
        <a (click)="openLink()" target="_blank" class="cursor-pointer text-neutral-900">
          <span class="fw-semibold f-small me-1">{{evidence?.title}}</span>
          <ui-streamline-icon [slIcon]="{name: 'interface-arrows-expand-5', theme: 'micro-bold', size: 'sm'}" class="pb-1"></ui-streamline-icon>
        </a>
      } @else {
        <p class="fw-semibold f-small">{{evidence?.title}}</p>
      }
      <p class="f-small">{{evidence?.description || 'No Description'}}</p>
      <p class="f-small"><span class="fw-semibold me-2 text-neutral-700">{{managerFullName}}</span><span class="text-neutral-700">{{evidence?.createTime | dateToDDMMMYYYY}}</span></p>
    </div>
  </div>

  <div (click)="deleteEvidence()" class="m-delete-icon">
    <ui-streamline-icon [slIcon]="{name: 'interface-delete-bin-1', theme: 'micro-bold', color: 'fill-danger', size: 'sm'}" class="pb-1"></ui-streamline-icon>
  </div>
</div>
